import { HeadLightbulbOutlineIcon } from './HeadLightbulbOutlineIcon';

/**
 * author: Michael Irigoyen
 * id A7FCF7AB-00BF-404B-8AF6-B384B034B6F7
 * name head-lightbulb-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/head-lightbulb-outline.svg
 * tags
 */
export const HeadIdeaOutlineIcon = HeadLightbulbOutlineIcon;
export default HeadIdeaOutlineIcon